import { CSSProgressiveBody03Semibold } from "@caisy/league";
import styled from "styled-components";

export const SMaintenanceWarningLoginTitle = styled.h2`
  ${CSSProgressiveBody03Semibold};
  color: var(--text-01);
`;
